import React, { FC } from 'react'
import { Chip, Avatar, ChipProps } from '@material-ui/core'
import { Tag } from 'Models/Tag/@types';

export interface TagChipProps extends Omit<ChipProps, 'label' | 'avatar' | 'onDelete'> {
    tag: Tag;
    onDelete?: (tag: Tag) => void;
}

const TagChip: FC<TagChipProps> = (props) => {
    const { tag: { name, _picture }, onDelete, ...chipProps } = props;

    const handleDelete = () => onDelete?.(props.tag);

    return (
        <Chip
            label={name}
            avatar={_picture?.thumbnailUrl ? <Avatar src={_picture?.thumbnailUrl} /> : undefined}
            onDelete={handleDelete}
            {...chipProps}
        />
    )
}

export default TagChip